import React from 'react';

import RequestDetailPage from './RequestDetailPage';
import { waitingActsFallbackDetails } from './requestQueueFallbacks';


export default function WaitingActsDetailPage() {
    return (
        <RequestDetailPage
            title="Ожидание актов"
            backTo="/app/acts/waiting"
            backLabel="Назад к актам"
            mode="acts"
            fallbackDetails={waitingActsFallbackDetails}
        />
    );
}
